import { ExportItem } from "../model/export-item.model";
import { ResourceService } from "./resource.service";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalSettings } from "../model/settings.model";
import { AuthenticationService } from "./auth.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import * as XLSX from 'xlsx';
import { SearchParamsModel } from "../model/search-params.model";
import swal from 'sweetalert2';

@Injectable({
    providedIn: 'root'
})
export class ExportService extends ResourceService<ExportItem[]> {

    constructor(
        http: HttpClient, 
        settings: GlobalSettings, 
        authService: AuthenticationService) {
            super(http, "reports", settings.reportUrl, authService)
    }

    async exportAsync(modelFilters: SearchParamsModel): Promise<void> {
      let items: any = [];

      await this.getItemsByPaginateAsync(1, modelFilters, items);
  
      try {
        if (items && items.length > 0)
          this.genereteFile(items);
        else
          swal.fire("Atenção", "A busca não resultou em nenhum item.", "info");
      }
      catch (e) {
        swal.fire("Atenção", "Problema na geração do relatório, tente novamente.", "error");
      }
    }

    private async getItemsByPaginateAsync(pageNumber: number, modelFilters: SearchParamsModel, items: any[]): Promise<any[]> {
      const pageSize: number = 50;
  
      const dataPaginate: any = await this.getItems(pageNumber, pageSize, modelFilters).toPromise();

      for(let item of dataPaginate.items) {
        items.push(item);
      }
  
      pageNumber += 1;
  
      if (pageNumber <= dataPaginate.totalPages)
        await this.getItemsByPaginateAsync(pageNumber, modelFilters, items);
  
      return items;
    }

    private getItems(pageNumber: number, pageSize: number, modelFilters: SearchParamsModel) : Observable<ExportItem[]> {
      let params = this.BuildProcessSearchParams(pageNumber, pageSize, { searchParams: modelFilters });
      
      return this.getWithComplement(`?${params.toString()}`);
    }

    private genereteFile(items: ExportItem[]) : void {

        var workbook = XLSX.utils.book_new();

        var plainObjects = items.map(i => this.getPlainObject(i))

        plainObjects.unshift(this.getHeader(items[0]));

        var ws1 = XLSX.utils.json_to_sheet(plainObjects, { skipHeader: true});
                XLSX.utils.book_append_sheet(
                  workbook,
                  ws1,
                  "Plan 1"
                );

        workbook.Props = {};        
        workbook.Props.Title = "EXPORT";
        workbook.Props.Subject = "EXPORT";
        //workbook.Props.Company = "MarketClub";

        XLSX.writeFile(
            workbook,
            `EXPORT${new Date().getTime()}.xlsx`
        );        

        console.log("File Generated ....");

    }

    private getPlainObject(item: ExportItem) : any {
        let obj: any = {};
        //obj.tipo = item.tipo;
        
        if(item.attributes) {
            item.attributes.forEach(attr => obj[attr.key]=attr.value)
        }

        // obj.creationDate = item.creationDate;
        // obj.actionStep = item.actionStep;
        // obj.action = item.action;
        // obj.complemento = item.complemento;
        // obj.actionDate = item.actionDate;
        // obj.elapsedTime = item.elapsedTime;
        // obj.login = item.login;
        // obj.nomeUsuario = item.nomeUsuario;
        // obj.migrated = item.migrated;
        // obj.currentStep = item.currentStep;
        return obj;
    }

    private getHeader(item: ExportItem) : any {
        let header: any = {};
        //header.tipo = "Tipo";
        
        if(item.attributes) {
            item.attributes.forEach(attr => header[attr.key]=attr.key)
        }

        // header.creationDate = "Data da Criação";
        // header.actionStep = "Fase";
        // header.action = "Ação";
        // header.complemento = "Complemento";
        // header.actionDate = "Data";
        // header.elapsedTime = "SLA";
        // header.login = "Login";
        // header.nomeUsuario = "Nome do Usuário";
        // header.migrated = "Migrado";
        // header.currentStep = "Fase Atual";
        return header;
    }
}